export const personalDataMutationSitecoreLabels = {
  HeadingOldName: { value: "Van wie wil je persoonsgegevens wijzigen" },
  HeadingSalutation: { value: "Aanhef" },
  InfoSalutation: { value: "" },
  PlaceholderSalutation: { value: "" },
  TooltipSalutation: { value: "" },
  HeadingInitials: { value: "Voorletter(s)" },
  InfoInitials: { value: "" },
  PlaceholderInitials: { value: "Voorletter(s)" },
  TooltipInitials: { value: "" },
  HeadingFirstName: { value: "Voornaam" },
  InfoFirstName: { value: "" },
  PlaceholderFirstName: { value: "Voornaam" },
  TooltipFirstName: { value: "" },
  HeadingInserts: { value: "Tussenvoegsel(s)" },
  InfoInserts: { value: "" },
  PlaceholderInserts: { value: "Tussenvoegsel(s)" },
  TooltipInserts: { value: "" },
  HeadingPartnerInserts: { value: "Tussenvoegsel(s)" },
  InfoPartnerInserts: { value: "" },
  PlaceholderPartnerInserts: { value: "Tussenvoegsel(s)" },
  TooltipPartnerInserts: { value: "" },
  HeadingLastName: { value: "Achternaam" },
  InfoLastName: { value: "" },
  PlaceholderLastName: { value: "Achternaam" },
  TooltipLastName: { value: "" },
  HeadingPartnerLastName: { value: "Achternaam partner" },
  InfoPartnerLastName: { value: "" },
  PlaceholderPartnerLastName: { value: "Achternaam partner" },
  TooltipPartnerLastName: { value: "" },
  HeadingUsePartnerName: { value: "Wil je (ook) de achternaam van je partner gebruiken?" },
  HeadingUseOfName: { value: "Naamgebruik" },
};
